import { $$4 } from 'global';

class TymFooterMenus extends HTMLElement {
  connectedCallback() {
    this.columns = $$4('.tym-ft__col', this);
    if (!this.columns.length) return;

    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    this.wide = window.matchMedia('(min-width: 768px)');

    this.columns.forEach((column) => {
      const head = column.querySelector('.tym-ft__col-head');
      if (!head) return;
      head.addEventListener('click', () => this.toggle(column), { signal });
    });

    this.wide.addEventListener('change', () => this.reset(), { signal });
    this.reset();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  toggle(column) {
    if (this.wide.matches) return;
    this.setState(column, column.getAttribute('data-open') !== 'true');
  }

  reset() {
    this.columns.forEach((column) => this.setState(column, this.wide.matches));
  }

  setState(column, open) {
    column.setAttribute('data-open', open ? 'true' : 'false');
    const head = column.querySelector('.tym-ft__col-head');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (!customElements.get('tym-footer-menus')) {
  customElements.define('tym-footer-menus', TymFooterMenus);
}
